module.exports = __webpack_public_path__ + "img/cases02.219a962f.png";